import {createAction, props} from '@ngrx/store';
import {UserActivityLog} from '../models/user-activity-log.model';





/**
 *
 * when the user activity is loaded via loadUserActivity, save it in the store
 *
 */

export const userActivityLoaded = createAction(
  '[User Activity Effects] User Activity Loaded',
  props<{courseId:string, events: UserActivityLog[]}>()
);
